import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useEffect, useRef, useState } from 'react';
const TYPEWRITER_INTERVAL_MS = 25;
const VISIBLE_DURATION_MS = 3000;
const FADE_DURATION_MS = 500;
const SUGGESTIONS_KEY_SEPARATOR = ' ';
export const useTypewriterLoop = (param)=>{
    let { disabled, value, suggestions } = param;
    const [state, setState] = useState({
        cycle: 0,
        currentSuggestionIndex: 0,
        displayedText: '',
        isTyping: true,
        opacity: 1
    });
    const suggestionsRef = useRef(suggestions);
    suggestionsRef.current = suggestions;
    const suggestionsKey = suggestions.join(SUGGESTIONS_KEY_SEPARATOR);
    useEffect(()=>{
        if (disabled || value || suggestionsRef.current.length === 0) {
            setState({
                cycle: 0,
                currentSuggestionIndex: 0,
                displayedText: '',
                isTyping: false,
                opacity: 0
            });
            return;
        }
        let timeoutId;
        let typingTimeoutId;
        let fadeTimeoutId;
        const currentSuggestion = suggestionsRef.current[state.currentSuggestionIndex];
        let charIndex = 0;
        const typeNextChar = ()=>{
            if (charIndex < currentSuggestion.length) {
                setState((prev)=>_object_spread_props(_object_spread({}, prev), {
                        displayedText: currentSuggestion.slice(0, charIndex + 1)
                    }));
                charIndex++;
                typingTimeoutId = setTimeout(typeNextChar, TYPEWRITER_INTERVAL_MS);
            } else {
                setState((prev)=>_object_spread_props(_object_spread({}, prev), {
                        isTyping: false
                    }));
                timeoutId = setTimeout(()=>{
                    setState((prev)=>_object_spread_props(_object_spread({}, prev), {
                            opacity: 0
                        }));
                    fadeTimeoutId = setTimeout(()=>{
                        setState((prev)=>({
                                cycle: prev.cycle + 1,
                                currentSuggestionIndex: (prev.currentSuggestionIndex + 1) % suggestionsRef.current.length,
                                displayedText: '',
                                isTyping: true,
                                opacity: 1
                            }));
                    }, FADE_DURATION_MS);
                }, VISIBLE_DURATION_MS);
            }
        };
        setState((prev)=>_object_spread_props(_object_spread({}, prev), {
                opacity: 1,
                isTyping: true,
                displayedText: ''
            }));
        typeNextChar();
        return ()=>{
            clearTimeout(timeoutId);
            clearTimeout(typingTimeoutId);
            clearTimeout(fadeTimeoutId);
        };
    }, [
        disabled,
        value,
        state.cycle,
        state.currentSuggestionIndex,
        suggestionsKey
    ]);
    return {
        displayedText: state.displayedText,
        isTyping: state.isTyping,
        opacity: state.opacity,
        duration: FADE_DURATION_MS / 1000
    };
};
